"use client";

import React from "react";
import { TabsProvider } from "./TabsContext";
import { cn } from "utils/utils";

interface TabsProps {
  children: React.ReactNode;
  defaultValue?: string | number;
  value?: string | number; // Controlled mode
  onValueChange?: (value: string | number) => void;
  className?: string;
  variant?: "border" | "boxed" | "lift";
}

export function Tabs({
  children,
  defaultValue,
  value,
  onValueChange,
  className,
  variant = "border",
}: TabsProps) {
  return (
    <TabsProvider
      defaultValue={defaultValue}
      onTabChange={onValueChange}
      variant={variant}
      controlledValue={value}
    >
      <div className={cn("w-full", className)}>{children}</div>
    </TabsProvider>
  );
}
